export default __webpack_public_path__ + "static/media/kreempieguy.4f676b1a.jpeg";